(function () {
  "use strict";
  if (window.gwpGalleryControls) { window.gwpGalleryControls.init(document); return; }
  var instances = new Map();
  var DEFER_SRC = 'data-gwp-defer-src', DEFER_SRCSET = 'data-gwp-defer-srcset';
  // Restores an image deferred by snippets/gwp-lcp-gate.liquid; returns true if it was deferred.
  function hydrate(img) {
    if (!img || !(img.hasAttribute(DEFER_SRC) || img.hasAttribute(DEFER_SRCSET))) return false;
    if (typeof window.gwpHydrate === 'function') { window.gwpHydrate(img); return true; }
    var srcset = img.getAttribute(DEFER_SRCSET), src = img.getAttribute(DEFER_SRC);
    if (srcset !== null) { img.removeAttribute(DEFER_SRCSET); img.setAttribute('srcset', srcset); }
    if (src !== null) { img.removeAttribute(DEFER_SRC); img.setAttribute('src', src); }
    return true;
  }
  function init(root) {
    root.querySelectorAll('[data-gwp-gallery-controls]').forEach(function (controls) {
      if (instances.has(controls)) return;
      var gallery = document.getElementById(controls.dataset.gwpGalleryControls);
      if (!gallery) return;
      var slides = Array.from(gallery.querySelectorAll('.gwp-gallery-item'));
      if (slides.length < 2) return;
      var host = controls.parentElement;
      var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
      var enabled = controls.dataset.autoplay === 'true' && !motion.matches;
      var hovered = false, touching = false, focused = false, visible = false;
      var timer = null, scrollTimer = null, cancelWait = null;
      var toggle = controls.querySelector('[data-gallery-toggle]');
      var count = controls.querySelector('[data-gallery-count]');
      var cleanup = [];
      function on(target, event, callback, options) {
        target.addEventListener(event, callback, options);
        cleanup.push(function () { target.removeEventListener(event, callback, options); });
      }
      function index() {
        var origin = gallery.getBoundingClientRect().left;
        var distances = slides.map(function (slide) { return Math.abs(slide.getBoundingClientRect().left - origin); });
        return distances.indexOf(Math.min.apply(null, distances));
      }
      function stop() {
        clearTimeout(timer); timer = null;
        if (cancelWait) cancelWait();
      }
      function schedule() {
        stop();
        if (!enabled || !visible || document.hidden || hovered || touching || focused) return;
        timer = setTimeout(advance, 4000);
      }
      function prepare(img) {
        img.loading = 'eager';
        var pic = img.parentNode && img.parentNode.nodeName === 'PICTURE' ? img.parentNode.querySelectorAll('source[' + DEFER_SRCSET + ']') : [];
        for (var i = 0; i < pic.length; i++) hydrate(pic[i]);
        return hydrate(img);
      }
      // Autoplay only moves to a slide whose image has finished loading; a failed image skips the wait.
      // The 500 ms re-check covers an image that had already failed before the wait began. stop() cancels the wait.
      function advance() {
        timer = null;
        var img = slides[(index() + 1) % slides.length].querySelector('img');
        var fresh = img ? prepare(img) : false;
        if (!img || (!fresh && img.complete && img.naturalWidth > 0)) { move(1); return; }
        function done() { cancelWait(); move(1); }
        var recheck = setInterval(function () { if (img.complete) done(); }, 500);
        cancelWait = function () {
          clearInterval(recheck);
          img.removeEventListener('load', done);
          img.removeEventListener('error', done);
          cancelWait = null;
        };
        img.addEventListener('load', done);
        img.addEventListener('error', done);
      }
      function update() {
        count.textContent = (index() + 1) + ' / ' + slides.length;
        if (toggle) {
          toggle.setAttribute('aria-label', enabled ? toggle.dataset.pauseLabel : toggle.dataset.playLabel);
          toggle.firstElementChild.textContent = enabled ? 'Ⅱ' : '▶';
        }
      }
      function move(delta) {
        var next = (index() + delta + slides.length) % slides.length;
        var img = slides[next].querySelector('img');
        if (img) prepare(img);
        var left = gallery.scrollLeft + slides[next].getBoundingClientRect().left - gallery.getBoundingClientRect().left;
        gallery.scrollTo({ left: left, behavior: motion.matches ? 'instant' : 'smooth' });
        schedule();
      }
      on(controls.querySelector('[data-gallery-prev]'), 'click', function () { move(-1); });
      on(controls.querySelector('[data-gallery-next]'), 'click', function () { move(1); });
      if (toggle) on(toggle, 'click', function () { enabled = !enabled; update(); schedule(); });
      on(gallery, 'scroll', function () {
        stop(); clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () { update(); schedule(); }, 180);
      }, { passive: true });
      on(host, 'pointerenter', function (event) { if (event.pointerType === 'mouse' && fine.matches) { hovered = true; stop(); } });
      on(host, 'pointerleave', function () { hovered = false; schedule(); });
      on(gallery, 'touchstart', function () { touching = true; stop(); }, { passive: true });
      on(window, 'touchend', function () { if (touching) { touching = false; schedule(); } }, { passive: true });
      on(window, 'touchcancel', function () { touching = false; schedule(); }, { passive: true });
      on(host, 'focusin', function (event) { focused = event.target.matches(':focus-visible'); if (focused) stop(); });
      on(host, 'focusout', function (event) { if (!host.contains(event.relatedTarget)) { focused = false; schedule(); } });
      on(host, 'keydown', function (event) {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); focused = true; move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      on(document, 'visibilitychange', function () { if (!document.hidden) { touching = false; hovered = false; } schedule(); });
      on(window, 'pageshow', function () { touching = false; hovered = false; update(); schedule(); });
      on(window, 'pagehide', stop);
      on(window, 'resize', function () { update(); schedule(); });
      on(motion, 'change', function () { if (motion.matches) enabled = false; update(); schedule(); });
      var observer = new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; schedule(); }, { threshold: 0.15 });
      observer.observe(gallery);
      controls.hidden = false;
      update();
      instances.set(controls, function () { stop(); clearTimeout(scrollTimer); observer.disconnect(); cleanup.forEach(function (remove) { remove(); }); instances.delete(controls); });
    });
  }
  window.gwpGalleryControls = { init: init };
  var booted = false;
  function boot() {
    if (booted || document.readyState === 'loading') return;
    booted = true;
    document.removeEventListener('readystatechange', boot);
    document.removeEventListener('DOMContentLoaded', boot);
    init(document);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('readystatechange', boot);
    document.addEventListener('DOMContentLoaded', boot);
  } else boot();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { instances.forEach(function (dispose, controls) { if (event.target.contains(controls)) dispose(); }); });
})();
